/**
 * A flow map on a CRM page: loaded, editable when allowed, saved as it is drawn.
 *
 * The map of one guide or project (`useFlowMapDoc`) handed to `FlowMapCard`,
 * which draws it with the CRM's words, save status, conflict banner and
 * history. See the card for what `emptyState`, `quiet` and `expected` do.
 */
import { starterFlowDoc, type FlowMapDoc } from "@wa/widgets/flow-map/model";
import { FlowMapCard, type FlowMapCardProps } from "./FlowMapCard";
import { useFlowMapDoc } from "./useFlowMapDoc";

export type FlowMapPanelProps = Omit<FlowMapCardProps, "map">;

/** A three-step map in the CRM's language: what "start empty" puts on the canvas. */
export function crmStarterDoc(t: (key: string) => string): FlowMapDoc {
  return starterFlowDoc({
    start: t("flowMap.starter.start"),
    step: t("flowMap.starter.step"),
    end: t("flowMap.starter.end"),
  });
}

export function FlowMapPanel(props: FlowMapPanelProps) {
  const map = useFlowMapDoc(props.owner, props.ownerId);
  return <FlowMapCard {...props} map={map} />;
}
